import React, {Component} from 'react'
import PortfolioGrid from './../../Components/PortfolioGrid'
import Data from './../../Data'

class Portfolio extends Component {
  render() {
    const reconstructions = Data.getReconstructions()

    const grids = reconstructions.map((data) =>
      <PortfolioGrid data={data} key={data.id} />
    )

    return (
      <div>
        {grids}
      </div>
    )
  }
}

export default Portfolio



// WEBPACK FOOTER //
// ./src/App/Portfolio/index.js